import {useEffect, useState} from 'react';
import styles from './marketing.module.scss';
import { Section01, Section02, Section03to05, Section06, Section07, Section08, Section09, Section10, Section11, Section12, Section13, Section14, Section15to16, Section17 } from './Section'

const Marketing = () => {
	const [play, setPlay] = useState(false)

	const [pageYOffset, setPageYOffset] = useState(0)
	const [innerHeight, setInnerHeight] = useState(0)

	const onPlay = () => {
		if (play) return;
		window.scrollTo(0, 0);
		setPlay(true)
	}

	const handleScroll = () => {
		setPageYOffset(window.pageYOffset)
		setInnerHeight(window.innerHeight)
	}

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	});

	const run = (props) => {
		// console.log(props.pageYOffset, props.innerHeight)
		if (pageYOffset === 0 || innerHeight === 0) return 0
		const last = props.ranges[props.ranges.length - 1][1]
		if (!last) return

		if (pageYOffset - (innerHeight * props.ranges[0][0]) < 0) {
			// 초기값
			// console.log('before')
			return 0
		} else if (pageYOffset - (innerHeight * last) >= 0) {
			// 마지막값
			// console.log('after')
			return props.ranges.length
		}
		let index = 0
		for (const [from, to] of props.ranges) {
			// console.log(from, to)
			if (typeof from !== 'number' || typeof to !== 'number') continue

			const fromOffset = pageYOffset - (innerHeight * from)
			const toOffset = pageYOffset - (innerHeight * to)
			if (fromOffset >= 0 && toOffset < 0) {
				// 프레임 분할 비율 (0 ~ 1)
				const fraction = fromOffset / (innerHeight * (to - from))
				// if (index > 1)
				//     console.log(index + fraction)
				return index + fraction
			}
			index += 1
		}
		return 0
	}

	const sectionTransition = {
		normalSection: { opacityRange: [0, 0.01, 0.99, 1], opacityOutput: [0, 1, 1, 0] },
		fillingWord: { opacityRange: [0, 0.1, 2.95, 3], opacityOutput: [0, 1, 1, 0] },
		doubleSection: { opacityRange: [0, 0.15, 1.85, 2], opacityOutput: [0, 1, 1, 0] },
		noFadeOutSection: { opacityRange: [0, 0.01, 1], opacityOutput: [0, 1, 1] },
		firstSection: { opacityRange: [0, 0.85, 1], opacityOutput: [1, 1, 0] },
		lastSection: { opacityRange: [0, 0.15, 1], opacityOutput: [0, 1, 1] },
		from03To05: { opacityRange: [0, 0.15, 2.85, 3], opacityOutput: [0, 1, 1, 0] },
	}

	return (
		<div className={styles.wrap}>
			<div className={styles['content-body']}>
				<div className={styles['content-body__container']}>
					<Section01 play={play} onPlay={onPlay} />
					{play &&
						<>
							<Section02
								play={play}
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[0, 2.2]]}
								section={sectionTransition.firstSection}
								run={run}
							/>
							<Section03to05
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[2, 4], [4, 6], [6, 8.2]]}
								section={sectionTransition.from03To05}
								run={run}
							/>
							<Section06
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[8, 10], [10, 12.1]]}
								section={sectionTransition.doubleSection}
								run={run}
							/>
							<Section07
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[12, 14], [14, 16.6], [16, 19.1]]}
								section={sectionTransition.fillingWord}
								run={run}
							/>
							<Section08
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[18.3, 20.2]]}
								section={sectionTransition.normalSection}
								run={run}
							/>
							<Section09
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[20, 22], [22, 24], [24, 26.1]]}
								section={sectionTransition.fillingWord}
								run={run}
							/>
							<Section10
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[25.65, 28.2]]}
								section={sectionTransition.normalSection}
								run={run}
							/>
							<Section11
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[28, 30], [30, 32], [32, 34.1]]}
								section={sectionTransition.fillingWord}
								run={run}
							/>
							<Section12
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[33.65, 36.1]]}
								section={sectionTransition.normalSection}
								run={run}
							/>
							<Section13
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[36, 38.1]]}
								section={sectionTransition.normalSection}
								run={run}
							/>
							<Section14
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[38, 40.75]]}
								section={sectionTransition.noFadeOutSection}
								run={run}
							/>
							<Section15to16
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[40, 43.2]]}
								section={sectionTransition.normalSection}
								run={run}
							/>
							<Section17
								pageYOffset={pageYOffset} innerHeight={innerHeight}
								ranges={[[43, 44]]}
								section={sectionTransition.lastSection}
								run={run}
							/>
						</>
					}
				</div>
			</div>
		</div>
	);
};

export default Marketing;
